import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import UserAddressService from "../../services/useraddress/useraddress.service";
import SubdistrictDataTable from "./subdistrict-datatable";
import SubdistrictSearch from "./subdistrict-search";
import { PincodeAreaModel } from "../../models/cust-address/cust-address-model";
import AppLoading from '../app-loading/app-loading';

const AddSubdistrict: React.FC = () => {
  const { t } = useTranslation();
  const [subdistrictList, setSubdistrictList] = useState<PincodeAreaModel[]>([]);  
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);  
  const [pageNumber, setPageNumber] = useState<number>(1);  
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchTerm, setSearchTerm] = useState<string>('');

  useEffect(() => {
    fetchData(pageNumber, pageSize);
  }, []);

  const reloadPage = (val: boolean) => {
    if (val) {
      fetchData(pageNumber, pageSize);
    }
  };

  const fetchData = async (pageNumber: number, pageSize: number) => {
    setLoading(true);
    try {
      const response = await UserAddressService.getSubDistricts(pageNumber, pageSize);
        await setSubdistrictList(response.subDistricts);
        await setTotalRecords(response.totalRecords);
      }
     catch (error) {
      console.error("Error fetching data:", error);
       await setSubdistrictList([]);
       await setTotalRecords(0);
 
    }
    finally{
      setLoading(false);
    }
  };

  const fetchDataByFilter = async (searchTerm: string = '',pageNumber: number, pageSize: number ) => {
    setLoading(true);
    try {
      const response = await UserAddressService.getAllSubDistrictsByFilter(searchTerm,pageNumber, pageSize);
      setSubdistrictList(response.subDistricts);
      setTotalRecords(response.totalRecords);
    } catch (error) {
      console.error("Error fetching data:", error);
      setSubdistrictList([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = async (event: any) => {
    const newPageNumber = Math.floor(event.first / event.rows) + 1;
    const newPageSize = event.rows;
    setPageNumber(newPageNumber);
    setPageSize(event.rows);

    if (searchTerm) {
      fetchDataByFilter(searchTerm, newPageNumber, newPageSize);
    } else {
      fetchData(newPageNumber, newPageSize);
    }
  };
 
  
  return (
    <>
      <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
        <div className="col-12">
          <h5 className="ml-1 mb-0">{"Sub District"}</h5>
        </div>
        
        <SubdistrictSearch
          reloadPage={reloadPage}
          setLoading={setLoading}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          setSubdistrictList={setSubdistrictList}
          setTotalRecords={setTotalRecords}
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
        />

        <SubdistrictDataTable
          data={subdistrictList}
          NoofRecords={totalRecords}
          pageNumber={pageNumber}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          searchTerm={searchTerm}
          onDataUpdate={setSubdistrictList}
          fetchData={fetchData}
        />
      </div>
     
      {loading && <AppLoading />}
    </>
  );
};

export default AddSubdistrict;
